module.exports = __webpack_public_path__ + "img/icon-settings.57adb8ca.svg";